// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeader_root__noAzF","rowHeader":"TableHeader_rowHeader__wwYuc"};